
import { Name } from "../prm/name";
import { OptionMenu } from "../prm/option-menu";

const menu_items = [
  new Name("aflac", "Aflac"),
  new Name("ast", "American Stock and Transfer (AST)"),
  new Name("bny", "BNY Mellon"),
  new Name("broadridge", "Broadridge"),
  new Name("schwab", "CHARLES SCHWAB & CO."),
  new Name("continental", "Continental"),
  new Name("curian", "Curian Clearing"),
  new Name("duke", "Duke Energy"),
  new Name("e_trade", "E*TRADE"),
  new Name("edward", "Edward Jones"),
  new Name("empower", "Empower Retirement"),
  new Name("eq_shar", "EQ Shareowner Services"),
  new Name("fidelity", "Fidelity (National Financial Services)"),
  new Name("first_clearing", "First Clearing Corp(Wachovia & Wells Fargo)"),
  new Name("island", "Island Stock & Transfer"),
  new Name("issuer", "Issuer Direct"),
  new Name("jms", "Janney Montgomery Scott"),
  new Name("jp_morgan", "JP Morgan"),
  new Name("lincoln_advisory", "Lincoln Financial Advisors"),
  new Name("lincoln_securities", "Lincoln Financial Securities"),
  new Name("lpl", "Linsco Private Ledger (LPL)"),
  new Name("mni", "M & I Brokerage Services"),
  new Name("merrill", "Merrill Lynch"),
  new Name("morgan_stanley", "Morgan Stanley Smith Barney"),
  new Name("national_financial", "National Financial Services LLC"),
  new Name("options_brokers_xpress", "OptionsXpress/BrokersXpress"),
  new Name("pershing", "Pershing LLC"),
  new Name("rbc", "RBC Capital Markets"),
  new Name("sei_trust", "SEI Private Trust Company"),
  new Name("stifel_nicolaus", "Stifel, Nicolaus & Company Incorporated"),
  new Name("transfer_online", "Transfer Online"),
  new Name("v_stock", "V-Stock Transfer"),
  new Name("wachovia", "Wachovia Securities"),
  new Name("wachovia_inv.", "Wedbush Securities Inc."),
  new Name("lpl_corp", "LPL FINANCIAL CORPORATION"),
  new Name("other", "Other"),
];

class HoldingFirmMenu extends OptionMenu {
  constructor(name) {
    super(name, menu_items);
  }
}

const xfer_firm_name = new HoldingFirmMenu(
  new Name("xfer_firm_name", "Name of Delivering Firm"));
xfer_firm_name.super_text = "Name of Delivering Firm";


export { HoldingFirmMenu, xfer_firm_name };
